import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ClienteShow } from '../../components'
import * as clienteActionCreators from '../../redux/modules/cliente'
import * as ufActionCreators from '../../redux/modules/uf'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'

class ClienteShowContainer extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,

    fetchCliente: PropTypes.func.isRequired,
    destroyCliente: PropTypes.func.isRequired,

    fetchUf: PropTypes.func.isRequired,

    hideFlashMessage: PropTypes.func.isRequired,
  }

  state = {
    cliente: null
  }

  async componentDidMount () {
    if (this.props.id) {
      const cliente = await this.props.fetchCliente(this.props.id)
      const uf = await this.props.fetchUf(cliente.uf_id)
      this.setState({ cliente, uf })
    }
  }

  handleRedirectToNew = () => {
    this.props.history.push('/clientes/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/clientes/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyCliente(id)
    this.props.history.push('/clientes')
  }

  getPane = (match) => {
    if (match.params.pane) return match.params.pane
    return 'informacoes'
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <ClienteShow
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        cliente={this.state.cliente}
        uf={this.state.uf}
        pane={this.getPane(this.props.match)}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({cliente, uf, status}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      isLoading: status.getIn(['cliente', 'isLoading']) || status.getIn(['uf', 'isLoading']),
      cliente: cliente.get('id'),
      uf: uf.get('id')
    }
  }
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...clienteActionCreators,
    ...ufActionCreators,
    ...flashMessageAcionCreators
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ClienteShowContainer))
